<template>
  <div>
    <TwTable :searchData="searchData" :tableData="tableData" :tableConfig="tableConfig" :pageConfig="pageConfig"
      :filters="filters" :buttonList="buttonList" @resetBtn="resetBtn" @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick" @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox" @searchChange="searchChange" @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle" @handleSelsChange="handleSelsChange" @handleOperateEvent="handleOperateEvent">
      <template slot-scope="scope" slot="proportionDesc">
        <el-tag type="success" v-if="scope.row.proportionStatus == 1">宽松</el-tag>
        <el-tag type="warning" v-if="scope.row.proportionStatus == 2">紧张</el-tag>
        <el-tag type="danger" v-if="scope.row.proportionStatus == 3">约满</el-tag>
      </template>
    </TwTable>


    <!-- 费用设置 -->
    <el-dialog
      id="completeDialog"
      title="节假日设置"
      :visible.sync="addTaskdialogVisible"
      width="80%"
      top="70px"
      style="text-align: center"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addRuleForm"
        auto-complete="off"
        style="overflow-x: hidden; overflow-y: hidden; margin-right: 4%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="仓库" prop="warehouseId">
              <el-select
                filterable
                v-model="addForm.warehouseId"
                style="width: 100%"
                placeholder="请选择仓库"
              >
                <el-option
                  v-for="item in warehouseList"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                  :key="item.warehouseId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="节假日" prop="tdate">
              <el-date-picker
                v-model="addForm.tdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="假期说明">
              <el-input
                v-model="addForm.content"
                auto-complete="off"
                placeholder="请输入假期说明"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        
        <el-row
          type="flex"
          class="row-bg"
          justify="center"
        >
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
    
<script>
import {
  GetBookingDeliveryReport,
  exportBookingDeliveryReport,
  GetBookingHolidayList,
  AddBookingHoliday,
  bookingHolidayOperate
} from "@/api/bookingdelivery.js";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
export default {
  components: {
    TwTable,
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      warehouseList: [],
      addLoading: false,
      addTaskdialogVisible:false,
      addForm: {
        warehouseId:"",
        tdate: [],
        content:"",
        startDate:"",
        endDate:"",
      },
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showResetButton: true,
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
        },
        column: [
          // 表格列配置
          {
            prop: "warehouseName",
            label: "仓库",
            minWidth: "120",
          },
          {
            prop: "startDateDesc",
            label: "起始日期",
            minWidth: "120",
          },
          {
            prop: "endDateDesc",
            label: "结束日期",
            minWidth: "80",
          },
          {
            prop: "content",
            label: "说明",
            minWidth: "80",
          },
          {
            prop: "createUser",
            label: "创建人",
          },
          {
            prop: "createTime",
            label: "创建时间",
          },
          {
            prop: "isStartText",
            label: "状态",
          },
        ],
      },
      addFormRules: {
        content: [
          { required: true, message: "请输入假期说明", trigger: "blur" },
        ],
        warehouseId: [
          { required: true, message: "请选择仓库", trigger: "change" },
        ],
        tdate: [{ required: true, message: "请选择日期", trigger: "change" }],
      },
      searchData: {
        //搜索列配置
        search: [
          {
            type: "daterange",
            key: "ExpectedTime",
            label: "日期区间",
          },
          {
            type: "select",
            key: "ProportionStatus",
            label: "状态",
            multiple: true,
            clearable: true,
            options: [
              {
                label: "启用",
                value: '1',
              },
              {
                label: "禁用",
                value: '0',
              },
            ]
          }
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      filters: {
        ExpectedTime: []
      }
      //-------------
    };
  },
  methods: {

    handleEnable(){
      let rows = this.selectRows.rows;
      if (rows.length!=1) {
        this.$message({
          message: "请选择要启用的一行数据！",
          type: "error"
        });

        return;
      }
      if (rows[0].isStart){
          this.$message({
              message: "当前数据为启用状态，无需操作！",
              type: "success"
          });

          return;
      }
      let para = {
          bookingHolidayID: rows[0].bookingHolidayID,
          isStart:true,
        };

      bookingHolidayOperate(para).then(res => {
        if (res.data.success) {                
          this.$message({
            message: res.data.msg,
            type: "success"
          });
          this.initTable();
        } else {
          row.enabled = false;
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    handleStop(){
      let rows = this.selectRows.rows;
      if (rows.length!=1) {
        this.$message({
          message: "请选择要禁用的一行数据！",
          type: "error"
        });

        return;
      }
      if (!rows[0].isStart){
          this.$message({
              message: "当前数据为禁用状态，无需禁用！",
              type: "success"
          });

          return;
      }
      let para = {
          bookingHolidayID: rows[0].bookingHolidayID,
          isStart:false,
        };
      bookingHolidayOperate(para).then(res => {
        if (res.data.success) {                
          this.$message({
            message: res.data.msg,
            type: "success"
          });
          this.initTable();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    // 弹出添加
    addTaskdialog() {
      this.addTaskdialogVisible = true;
    },
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
      para.startDate=para.tdate[0];
      para.endDate=para.tdate[1];
      console.info(para);
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          AddBookingHoliday(para).then((res) => {
              this.addLoading = false;
              if (res.data.success) {
                this.addTaskdialogVisible = false;
                this.initTable();
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
        }
      });
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList;
    },
    initializeDates() {
      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 15); 

      const sevenDaysAfter = new Date(today);
      sevenDaysAfter.setDate(today.getDate() + 15);

      //this.filters.ExpectedTime=[this.formatDate(sevenDaysAgo),this.formatDate(sevenDaysAfter)];

      this.$set(this.filters, "ExpectedTime", [this.formatDate(sevenDaysAgo),this.formatDate(sevenDaysAfter)]);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    handleExport() {
      const { ProportionStatus } = this.filters;
      let para = {
        page: 1,
        pageSize: 60001,
        ...this.filters,
        ProportionStatus: ProportionStatus
      };
      this.exportFile(exportBookingDeliveryReport, para);

    },

    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    //查询列表
    initTable() {
      const { ProportionStatus } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize || 50,
        ...this.filters,
        ProportionStatus: ProportionStatus
      };
      this.getTableData(GetBookingHolidayList, para).then((res) => {

      })
    },
    getButtonIndex(fnName) {
      let fnIndex = 0
      this.buttonList.forEach((item, index) => {
        if (item.func == fnName) {
          fnIndex = index
          return
        }
      })
      return fnIndex
    },
    resetBtn() {
      //this.filters = { ExpectedTime: ["2023-10-24", "2023-11-23"] };
      this.initializeDates();
    },
  },

  mounted() {
    this.initializeDates();
    // 获取按钮配置
    this.getMixinsButtonList();
    this.getBasicdatalist();
  },
};
</script>
  